// Shared by both the server (web/routes/previewenv.ts) and the client (OverlayCandidatesStep.tsx)
// — same shape of "who shares an infra dependency" grouping needed on both sides to assign
// matching mirrord db_branches ids. See PLATENG-1612 plan for the cross-app shared-branch design.

/** Given a set of named entries and the infra dependency names each one has, returns only the
 *  depNames shared by 2 or more entries, mapped to the names that share them. A depName used by
 *  just one entry is omitted — that's the normal "no sharing" case, callers should fall back to
 *  their own per-entry id in that case. */
export function groupBySharedDep(
  entries: { name: string; depNames: string[] }[],
): Map<string, string[]> {
  const byDep = new Map<string, string[]>();
  for (const { name, depNames } of entries) {
    for (const depName of depNames) {
      const names = byDep.get(depName);
      if (names) names.push(name);
      else byDep.set(depName, [name]);
    }
  }
  for (const [depName, names] of byDep) {
    if (names.length < 2) byDep.delete(depName);
  }
  return byDep;
}
